module.exports = __webpack_public_path__ + "img/text_0.b113f477.png";